var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"change-details-c"},[_vm._l((_vm.items),function(item,itemIndex){return [_c('ChangeItem',{key:itemIndex,attrs:{"task":item}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }